import { render, staticRenderFns } from "./AssignAccountTypeDataTable.vue?vue&type=template&id=5f90205b"
import script from "./AssignAccountTypeDataTable.vue?vue&type=script&lang=js"
export * from "./AssignAccountTypeDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports